import { getPaths } from "@ingka/icon-store";
const SVGNS = "http://www.w3.org/2000/svg";
function svgNodeRenderer(nodes) {
  if (!nodes) return;
  return nodes.map((node) => {
    const res = document.createElementNS(SVGNS, node.tag);
    Object.keys(node.att).map(
      (attrName) => res.setAttribute(attrName, node.att[attrName])
    );
    const children = svgNodeRenderer(node.nds);
    if (children?.length) res.append(...children);
    return res;
  });
}
function renderIconDOM(icon) {
  return svgNodeRenderer(getPaths(icon));
}
export {
  renderIconDOM,
  svgNodeRenderer
};
